"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[354],{

/***/ 47743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* reexport */ Badge; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/functions/index.ts + 3 modules
var functions = __webpack_require__(83554);
;// CONCATENATED MODULE: ./src/components/Badge/Badge.tsx


const Badge = (param)=>{
    let { badgeContent , children , className =""  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,functions/* classNames */.AK)(className, "absolute -right-[25%] -top-[15%] z-10"),
                children: badgeContent
            }),
            children
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Badge/index.ts



/***/ }),

/***/ 78722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ Icon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _emberswap_emberswap_sdk2_dist_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34534);
/* harmony import */ var _emberswap_emberswap_sdk2_dist_entities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79334);
/* harmony import */ var _emberswap_emberswap_sdk2_dist_enums__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38489);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);







const BCHLogo = "https://raw.githubusercontent.com/emberswap/assets/master/blockchains/smartbch/assets/0x3743eC0673453E5009310C727Ba4eaF7b3a1cc04/logo.png";
const BnbLogo = "https://raw.githubusercontent.com/sushiswap/list/master/logos/native-currency-logos/bnb.svg";
const NativeLogo = {
    [_emberswap_emberswap_sdk2_dist_enums__WEBPACK_IMPORTED_MODULE_3__/* .ChainId.BSC */ .a_.BSC]: BnbLogo,
    [_emberswap_emberswap_sdk2_dist_enums__WEBPACK_IMPORTED_MODULE_3__/* .ChainId.BSC_TESTNET */ .a_.BSC_TESTNET]: BnbLogo,
    [_emberswap_emberswap_sdk2_dist_enums__WEBPACK_IMPORTED_MODULE_3__/* .ChainId.SMARTBCH */ .a_.SMARTBCH]: BCHLogo,
    [_emberswap_emberswap_sdk2_dist_enums__WEBPACK_IMPORTED_MODULE_3__/* .ChainId.SMARTBCH_TESTNET */ .a_.SMARTBCH_TESTNET]: BCHLogo
};
const Icon = (param)=>{
    let { currency , disableLink , width ="28" , height ="28" , priority  } = param;
    const [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false);
    // const [loading, setLoading] = useState(false)
    const src = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(()=>{
        if (currency.isNative) {
            return NativeLogo[currency.chainId];
        }
        if (currency instanceof _emberswap_emberswap_sdk2_dist_entities__WEBPACK_IMPORTED_MODULE_2__/* .WrappedTokenInfo */ .DT && currency.logoURI) {
            return currency.logoURI;
        }
        return "/images/utils/unknown.png";
    }, [
        currency
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(()=>{
        setError(false);
    }, [
        src
    ]);
    if (disableLink) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
            placeholder: width && height && Number(width) >= 40 && Number(height) >= 40 ? "blur" : "empty",
            blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAADhUlEQVRIx6VXz48UVRD+qmb6DXhQNoYYsy6rrFGMUSCYrDvgwauJ2cOGMTHGmzcjuAZiSNCOgWhUMGjixT9AYCFkb8aDMSQLRpCbF91FZRFcLuuvDUq26/PQs83rntc9PdJJJ/XmVb/6ql59VTWCGs/u3WzIpp92NgWTrcTazrDZJTbkjHDGZZfwsktsLjLMPrjy/bnOTCfpd6ZUbU68vrh+aN3qnpZh2hk3uoRwRkSpQaytC/KNKMGRe2/9+Ulnpn1zYMPPHvylExmOOuNwzkCJwQCYxWiV0y/NbD0VOl97fiFlV7wYC+S4AsPKVEkBKAFhilZ8ubuX6ZJQckSFJ09PXXovjqnVHsfUp/Hr547sREm1h84sWwdD761bCU9c2Lb9xTgWC3q8Q68dFqAjBBRcQ57KIISEoPt6Hue8LUaDAIAXdn536Z1gqLcevtpR8M3MgBfGtYO0J6Sop5fuHzj73IWpnOEHji6uV8qHuQ8LH0vISKmeH5n0VVAUcuzi8xfvygxvuNnYK8SIIpA4JWD8QwsGKkBzmLeSV9PkOsnGEz9ev+7zNE0My+SonLM5uVKvu24Zl+bv/nlYt8z/tkvJjVpA7odUWfQ2H+4yvVAEQd73+PKmCRXhZI6LA3PWA3M7pJkTGSu6cpe/k9ok2mVGipmp/sHM08unXX/Q0lYQm8Nc7M3MzECNyJSDBpQcUyHvCad/Pc6WFpBSPULADdqXs+zH2aIR9la93LV0E1GIPyo5G+S2z9m8kZqgf1cFFsLpX56ZtQsNSiM4r2qcC6f/nXO2t3avRcXmVERn74yzRTA+Z72E9e5XKLM6uuX+cwLcqEr/XjD5+83X676gl0bPTnyjMx1J1HBEAvdb7Mfql9OanO0FLR8IxBQApLH6sQJX/PutxdkBuJ3q8mr0r32atcWv44f+AfiGEByIswgNByyremyAr42cTyfPbAL58tDoKRW8q31p4nO2tx9XgD708FftM8GZa3tr9KASJ3qKQrFdDsZZNCDHH3tmPO4zV1Nenr78dmR8yxnlfzX92zKbhvd3TDx1QLwJs3Kgf2XPwpQz+ygyjtQf6M3fu+IS2zv+xfiZegN99/ns2Njplb+ajwiwX4ElzXeXcD8moJAlBfatrvz9aJnRvv+dsjk/puLaD+1mYpOthG1HG3MJh7oeL0fGBWecW0fMfvvktvNxIayh5z//1nKmShHglAAAAABJRU5ErkJggg==",
            onErrorCapture: ()=>setError(true),
            src: error ? "/images/utils/unknown.png" : src ? src : "/images/utils/unknown.png",
            alt: currency.name || "",
            className: "rounded-full select-none",
            priority: priority,
            width: width,
            height: height
        }, src);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
        target: "_blank",
        rel: "noreferrer",
        className: "flex",
        href: _emberswap_emberswap_sdk2_dist_constants__WEBPACK_IMPORTED_MODULE_1__/* .chains */ .p5[currency.chainId].getTokenUrl(currency.wrapped.address),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
            placeholder: width && height && Number(width) >= 40 && Number(height) >= 40 ? "blur" : "empty",
            blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAADhUlEQVRIx6VXz48UVRD+qmb6DXhQNoYYsy6rrFGMUSCYrDvgwauJ2cOGMTHGmzcjuAZiSNCOgWhUMGjixT9AYCFkb8aDMSQLRpCbF91FZRFcLuuvDUq26/PQs83rntc9PdJJJ/XmVb/6ql59VTWCGs/u3WzIpp92NgWTrcTazrDZJTbkjHDGZZfwsktsLjLMPrjy/bnOTCfpd6ZUbU68vrh+aN3qnpZh2hk3uoRwRkSpQaytC/KNKMGRe2/9+Ulnpn1zYMPPHvylExmOOuNwzkCJwQCYxWiV0y/NbD0VOl97fiFlV7wYC+S4AsPKVEkBKAFhilZ8ubuX6ZJQckSFJ09PXXovjqnVHsfUp/Hr547sREm1h84sWwdD761bCU9c2Lb9xTgWC3q8Q68dFqAjBBRcQ57KIISEoPt6Hue8LUaDAIAXdn536Z1gqLcevtpR8M3MgBfGtYO0J6Sop5fuHzj73IWpnOEHji6uV8qHuQ8LH0vISKmeH5n0VVAUcuzi8xfvygxvuNnYK8SIIpA4JWD8QwsGKkBzmLeSV9PkOsnGEz9ev+7zNE0My+SonLM5uVKvu24Zl+bv/nlYt8z/tkvJjVpA7odUWfQ2H+4yvVAEQd73+PKmCRXhZI6LA3PWA3M7pJkTGSu6cpe/k9ok2mVGipmp/sHM08unXX/Q0lYQm8Nc7M3MzECNyJSDBpQcUyHvCad/Pc6WFpBSPULADdqXs+zH2aIR9la93LV0E1GIPyo5G+S2z9m8kZqgf1cFFsLpX56ZtQsNSiM4r2qcC6f/nXO2t3avRcXmVERn74yzRTA+Z72E9e5XKLM6uuX+cwLcqEr/XjD5+83X676gl0bPTnyjMx1J1HBEAvdb7Mfql9OanO0FLR8IxBQApLH6sQJX/PutxdkBuJ3q8mr0r32atcWv44f+AfiGEByIswgNByyremyAr42cTyfPbAL58tDoKRW8q31p4nO2tx9XgD708FftM8GZa3tr9KASJ3qKQrFdDsZZNCDHH3tmPO4zV1Nenr78dmR8yxnlfzX92zKbhvd3TDx1QLwJs3Kgf2XPwpQz+ygyjtQf6M3fu+IS2zv+xfiZegN99/ns2Njplb+ajwiwX4ElzXeXcD8moJAlBfatrvz9aJnRvv+dsjk/puLaD+1mYpOthG1HG3MJh7oeL0fGBWecW0fMfvvktvNxIayh5z//1nKmShHglAAAAABJRU5ErkJggg==",
            onErrorCapture: ()=>setError(true),
            src: error ? "/images/utils/unknown.png" : src ? src : "/images/utils/unknown.png",
            alt: currency.name || "",
            className: "rounded-full",
            priority: priority,
            width: width,
            height: height
        }, src)
    });
};


/***/ }),

/***/ 50731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ Currency; }
});

// EXTERNAL MODULE: ./src/components/Currency/Icon.tsx
var Icon = __webpack_require__(78722);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/functions/index.ts + 3 modules
var functions = __webpack_require__(83554);
;// CONCATENATED MODULE: ./src/components/Currency/IconList.tsx



const IconList = (param)=>{
    let { children , iconWidth , iconHeight  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex items-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,functions/* classNames */.AK)("inline-flex space-x-[-17.5%]"),
            children: react.Children.map(children, (child)=>{
                if (/*#__PURE__*/ (0,react.isValidElement)(child)) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "z-10 inline-flex rounded-full shadow-sm shadow-black ring-1 ring-black/10",
                        children: /*#__PURE__*/ (0,react.cloneElement)(child, {
                            ...child.props,
                            width: iconWidth || child.props.width,
                            height: iconHeight || child.props.height
                        })
                    });
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-virtualized-auto-sizer/dist/index.esm.js
var index_esm = __webpack_require__(11728);
// EXTERNAL MODULE: ./node_modules/react-window/dist/index.esm.js + 5 modules
var dist_index_esm = __webpack_require__(52848);
;// CONCATENATED MODULE: ./src/components/Currency/List.tsx




/**
 * @param {any}param0 
 * @return {any}
 */ function List(param) {
    let { className , rowHeight , rowData , rowRenderer: RowComponent  } = param;
    const Row = (0,react.useCallback)((param)=>{
        let { index , style  } = param;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RowComponent, {
            style: style,
            ...rowData[index]
        });
    }, [
        RowComponent,
        rowData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* default */.Z, {
        disableWidth: true,
        children: (param)=>/*#__PURE__*/ {
            let { height  } = param;
            return (0,jsx_runtime.jsx)(dist_index_esm/* FixedSizeList */.t7, {
                width: "100%",
                height: height,
                itemCount: rowData.length,
                itemSize: rowHeight || 48,
                className: className,
                style: {
                    overflow: "overlay"
                },
                children: Row
            });
        }
    });
}

;// CONCATENATED MODULE: ./src/components/Currency/index.ts



const Currency = {
    List: List,
    Icon: Icon/* Icon */.J,
    IconList: IconList
};


/***/ }),

/***/ 78871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ix": function() { return /* reexport */ ToastContainer; },
  "rv": function() { return /* reexport */ createErrorToast; },
  "zb": function() { return /* reexport */ createFailedToast; },
  "Bh": function() { return /* reexport */ createInfoToast; },
  "yH": function() { return /* reexport */ createInlineToast; },
  "nj": function() { return /* reexport */ createSuccessToast; },
  "Yz": function() { return /* reexport */ createToast; }
});

// UNUSED EXPORTS: TOAST_OPTIONS

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/nanoid/index.browser.js
var index_browser = __webpack_require__(53416);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(22920);
// EXTERNAL MODULE: ./src/functions/index.ts + 3 modules
var functions = __webpack_require__(83554);
;// CONCATENATED MODULE: ./src/components/Toast/ToastButtons.tsx


const ToastButtons = (param)=>{
    let { href , onDismiss  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,functions/* classNames */.AK)(href ? "grid-cols-2" : "grid-cols-auto", "grid divide-x divide-slate-200/5"),
        children: [
            href && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: href,
                target: "_blank",
                rel: "noreferrer",
                className: "py-3 text-xs font-semibold text-center text-gray-300 border-t cursor-pointer hover:bg-slate-700/20 border-slate-200/5",
                children: "View Detail"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: onDismiss,
                className: "py-3 text-xs font-semibold text-center text-gray-300 border-t cursor-pointer hover:bg-slate-700/20 border-slate-200/5",
                children: "Dismiss"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@emberswap/emberswap-sdk2/dist/entities/index.mjs
var entities = __webpack_require__(79334);
// EXTERNAL MODULE: ./src/components/Icons/index.tsx + 54 modules
var Icons = __webpack_require__(66739);
// EXTERNAL MODULE: ./src/components/Copy/index.tsx
var Copy = __webpack_require__(55029);
;// CONCATENATED MODULE: ./src/components/Toast/ToastContent.tsx


const ToastContent = (param)=>{
    let { icon , title , summary , code =false  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-start gap-4 p-4",
        children: [
            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-0.5",
                children: icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col gap-1",
                children: !code ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "text-sm font-medium text-slate-50",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "text-xs text-slate-600",
                            children: summary
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Copy/* default */.Z, {
                            toCopy: summary ? summary.toString() : "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "text-sm font-medium text-slate-50",
                                children: title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "select-text scroll mt-2 gradient-backdrop-blur bg-slate-50/60 p-2 px-3 rounded-lg border border-slate-200/10 text-[10px] text-slate-600 break-all max-h-[80px] overflow-y-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                                children: summary
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Toast/ToastCompleted.tsx





const ToastCompleted = (param)=>{
    let { href , chainId , txHash , onDismiss , summary  } = param;
    var ref;
    var ref1;
    const txUrl = href ? href : (ref1 = (ref = entities/* Chain.from */.qo.from(chainId)) === null || ref === void 0 ? void 0 : ref.getTxUrl(txHash)) !== null && ref1 !== void 0 ? ref1 : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastContent, {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* CheckCircleIcon */.rE, {
                    width: 18,
                    height: 18,
                    className: "text-green-500"
                }),
                title: "Transaction Completed",
                summary: summary.completed
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastButtons, {
                href: txUrl,
                onDismiss: onDismiss
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Toast/ToastFailed.tsx





const ToastFailed = (param)=>{
    let { href , chainId , txHash , onDismiss , summary  } = param;
    var ref;
    var ref1;
    const txUrl = href ? href : (ref1 = (ref = entities/* Chain.from */.qo.from(chainId)) === null || ref === void 0 ? void 0 : ref.getTxUrl(txHash)) !== null && ref1 !== void 0 ? ref1 : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastContent, {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* XCircleIcon */.oO, {
                    width: 18,
                    height: 18,
                    className: "text-red-500"
                }),
                title: "Transaction Failed",
                summary: summary.failed
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastButtons, {
                href: txUrl,
                onDismiss: onDismiss
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Toast/ToastInfo.tsx





const ToastInfo = (param)=>{
    let { href , chainId , txHash , onDismiss , summary  } = param;
    var ref;
    var ref1;
    const txUrl = href ? href : (ref1 = (ref = entities/* Chain.from */.qo.from(chainId)) === null || ref === void 0 ? void 0 : ref.getTxUrl(txHash)) !== null && ref1 !== void 0 ? ref1 : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastContent, {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* HalfCircleIcon */.S8, {
                    width: 18,
                    height: 18,
                    className: "text-slate-50"
                }),
                title: "Transaction Info",
                summary: summary === null || summary === void 0 ? void 0 : summary.info
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastButtons, {
                href: txUrl,
                onDismiss: onDismiss
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Loader/index.tsx + 2 modules
var Loader = __webpack_require__(62817);
;// CONCATENATED MODULE: ./src/components/Toast/ToastPending.tsx





const ToastPending = (param)=>{
    let { href , chainId , txHash , onDismiss , summary  } = param;
    var ref;
    var ref1;
    const txUrl = href ? href : (ref1 = (ref = entities/* Chain.from */.qo.from(chainId)) === null || ref === void 0 ? void 0 : ref.getTxUrl(txHash)) !== null && ref1 !== void 0 ? ref1 : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastContent, {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader.Spinner */.a.Spinner, {
                    width: 18,
                    height: 18,
                    className: "text-blue-500"
                }),
                title: "Transaction Pending",
                summary: summary.pending
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastButtons, {
                href: txUrl,
                onDismiss: onDismiss
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Toast/ToastInline.tsx





const ToastInline = (param)=>{
    let { promise , onDismiss , ...props } = param;
    const [success, setSuccess] = (0,react.useState)(false);
    const [error, setError] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        promise.then(()=>{
            setSuccess(true);
            setTimeout(onDismiss, 5000);
        }).catch(()=>{
            setError(true);
            setTimeout(onDismiss, 5000);
        });
    }, [
        onDismiss,
        promise
    ]);
    if (success) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastCompleted, {
        onDismiss: onDismiss,
        ...props
    });
    if (error) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastFailed, {
        onDismiss: onDismiss,
        ...props
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastPending, {
        onDismiss: onDismiss,
        ...props
    });
};

;// CONCATENATED MODULE: ./src/components/Toast/Toast.tsx











const TOAST_OPTIONS = {
    position: "bottom-left",
    autoClose: false,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
    closeButton: false,
    icon: false
};
const createInlineToast = (props)=>{
    const onDismiss = ()=>react_toastify_esm/* toast.dismiss */.Am.dismiss(props.txHash);
    return (0,react_toastify_esm/* toast */.Am)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ToastInline, {
        ...props,
        onDismiss: onDismiss
    }), {
        ...TOAST_OPTIONS,
        toastId: props.txHash
    });
};
const createToast = (props)=>{
    const onDismiss = ()=>react_toastify_esm/* toast.dismiss */.Am.dismiss(props.txHash);
    // Spawn new toasts based on promise result
    props.promise.then(()=>{
        setTimeout(onDismiss, 3000);
        // Spawn success notification
        const toastId = "completed:".concat(props.txHash);
        (0,react_toastify_esm/* toast */.Am)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ToastCompleted, {
            ...props,
            onDismiss: ()=>react_toastify_esm/* toast.dismiss */.Am.dismiss(toastId)
        }), {
            ...TOAST_OPTIONS,
            toastId,
            autoClose: 5000
        });
    }).catch(()=>{
        setTimeout(onDismiss, 3000);
        // Spawn error notification
        const toastId = "failed:".concat(props.txHash);
        (0,react_toastify_esm/* toast */.Am)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ToastFailed, {
            ...props,
            onDismiss: ()=>react_toastify_esm/* toast.dismiss */.Am.dismiss(toastId)
        }), {
            ...TOAST_OPTIONS,
            toastId
        });
    });
    return (0,react_toastify_esm/* toast */.Am)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ToastPending, {
        ...props,
        onDismiss: onDismiss
    }), {
        ...TOAST_OPTIONS,
        toastId: props.txHash
    });
};
const createErrorToast = (message, code)=>{
    if (!message) return;
    const toastId = "failed:".concat((0,index_browser/* nanoid */.x0)());
    (0,react_toastify_esm/* toast */.Am)(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastContent, {
                title: "Error Occurred",
                summary: message,
                code: code
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastButtons, {
                onDismiss: ()=>react_toastify_esm/* toast.dismiss */.Am.dismiss(toastId)
            })
        ]
    }), {
        ...TOAST_OPTIONS,
        toastId
    });
};
const createSuccessToast = (props)=>{
    const toastId = "completed:".concat(props.txHash);
    (0,react_toastify_esm/* toast */.Am)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ToastCompleted, {
        ...props,
        onDismiss: ()=>react_toastify_esm/* toast.dismiss */.Am.dismiss(toastId)
    }), {
        ...TOAST_OPTIONS,
        toastId,
        autoClose: 5000
    });
};
const createFailedToast = (props)=>{
    const toastId = "failed:".concat(props.txHash);
    (0,react_toastify_esm/* toast */.Am)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ToastFailed, {
        ...props,
        onDismiss: ()=>react_toastify_esm/* toast.dismiss */.Am.dismiss(toastId)
    }), {
        ...TOAST_OPTIONS,
        toastId,
        autoClose: 5000
    });
};
const createInfoToast = (props)=>{
    const toastId = "info:".concat(props.txHash);
    (0,react_toastify_esm/* toast */.Am)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ToastInfo, {
        ...props,
        onDismiss: ()=>react_toastify_esm/* toast.dismiss */.Am.dismiss(toastId)
    }), {
        ...TOAST_OPTIONS,
        toastId,
        autoClose: 5000
    });
};

// EXTERNAL MODULE: ./node_modules/react-toastify/dist/ReactToastify.css
var ReactToastify = __webpack_require__(64213);
;// CONCATENATED MODULE: ./src/components/Toast/ToastContainer.tsx



const ToastContainer = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_toastify_esm/* ToastContainer */.Ix, {
        newestOnTop: true,
        bodyClassName: ()=>"mx-4 flex flex-col ring-1 ring-black/20 bg-slate-800/50 gradient-backdrop-blur  shadow-md mt-4 md:mt-2 rounded-xl overflow-hidden",
        toastClassName: ()=>"",
        className: className
    });
};

;// CONCATENATED MODULE: ./src/components/Toast/index.tsx




/***/ }),

/***/ 54218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Tooltip; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);
/* harmony import */ var react_popper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95237);
/* harmony import */ var _functions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83554);
/* harmony import */ var _hooks_utils_useDebounce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36175);






const Tooltip = (param)=>{
    let { panel , button , placement ="bottom" , className =""  } = param;
    const [referenceElement, setReferenceElement] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [popperElement, setPopperElement] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [arrowElement, setArrowElement] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [debouncedHover, setDebouncedHover] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [hover, setHover] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const DebouncedHover = (0,_hooks_utils_useDebounce__WEBPACK_IMPORTED_MODULE_4__/* .useDebounce */ .N)([
        debouncedHover,
        hover
    ], 200);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const [debouncedHover] = DebouncedHover;
        setHover(debouncedHover);
    }, [
        DebouncedHover
    ]);
    const { styles , attributes , update  } = (0,react_popper__WEBPACK_IMPORTED_MODULE_5__/* .usePopper */ .D)(referenceElement, popperElement, {
        placement,
        strategy: "fixed",
        modifiers: [
            {
                name: "offset",
                options: {
                    offset: [
                        0,
                        12
                    ]
                }
            },
            {
                name: "arrow",
                options: {
                    element: arrowElement,
                    padding: 500
                }
            }
        ]
    });
    const onHover = (show)=>{
        if (show) {
            setHover(true);
            setDebouncedHover(true);
            update && update();
        } else {
            setTimeout(()=>{
                setDebouncedHover(false);
                update && update();
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        id: "refelement",
        "aria-describedby": "tooltip",
        ref: setReferenceElement,
        onMouseLeave: ()=>onHover(false),
        onMouseEnter: ()=>onHover(true),
        children: [
            button,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    role: "tooltip",
                    id: "tooltip",
                    className: (0,_functions__WEBPACK_IMPORTED_MODULE_3__/* .classNames */ .AK)(className, "z-[1280] select-none block leading-normal  bg-slate-700 text-slate-200 text-xs px-3 py-2 rounded-lg ", Boolean(!hover) ? "invisible opacity-0 pointer-events-none" : "opacity-1"),
                    ref: setPopperElement,
                    style: styles.popper,
                    ...attributes.popper,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            id: "arrow",
                            className: "!transition-none",
                            ref: setArrowElement,
                            "data-popper-arrow": true
                        }),
                        panel
                    ]
                }), document.querySelector("#__next"))
            })
        ]
    });
};


/***/ }),

/***/ 8350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xd": function() { return /* binding */ useCustomTokens; },
/* harmony export */   "rV": function() { return /* binding */ useSettings; },
/* harmony export */   "zn": function() { return /* binding */ useNotifications; }
/* harmony export */ });
/* harmony import */ var _emberswap_emberswap_sdk2_dist_entities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79334);
/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35035);
/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);
/* harmony import */ var _components_Toast__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78871);
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32149);
// import { AppDispatch, AppState, /* AppState*/ } from '..'
// import { BASES_TO_TRACK_LIQUIDITY_FOR, FACTORY_ADDRESS } from '../../constants'
// import { /* computePairAddress, JSBI, Pair, Percent,*/ Token } from '@emberswap/emberswap-sdk2'


// import { useAppDispatch, useAppSelector } from '..'




const useCustomTokens = (chainId)=>{
    const customTokens = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)((state)=>{
        var ref;
        return (ref = state.user) === null || ref === void 0 ? void 0 : ref.customTokens;
    });
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    const addCustomToken = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((param)=>{
        let { symbol , address , chainId , name , decimals  } = param;
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_5__/* .addCustomToken */ .bZ)({
            symbol,
            address,
            chainId,
            name,
            decimals
        }));
    }, [
        dispatch
    ]);
    const addCustomTokens = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((tokens)=>{
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_5__/* .addCustomTokens */ .rC)(tokens));
    }, [
        dispatch
    ]);
    const removeCustomToken = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((param)=>{
        let { address , chainId  } = param;
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_5__/* .removeCustomToken */ .Kg)({
            address,
            chainId
        }));
    }, [
        dispatch
    ]);
    const tokens = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (!chainId || !customTokens || !customTokens[chainId]) return {};
        return Object.entries(customTokens[chainId]).reduce((acc, param)=>{
            let [k, { chainId , decimals , name , symbol , address  }] = param;
            acc[k] = new _emberswap_emberswap_sdk2_dist_entities__WEBPACK_IMPORTED_MODULE_0__/* .Token */ .WU({
                chainId,
                decimals,
                name,
                symbol,
                address
            });
            return acc;
        }, {});
    }, [
        chainId,
        customTokens
    ]);
    return [
        tokens,
        {
            addCustomToken,
            removeCustomToken,
            addCustomTokens
        }
    ];
};
const useSettings = (chainId)=>{
    const { ...settings } = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)((state)=>state.user);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    const updateExpertMode = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((expertMode)=>{
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_5__/* .updateUserExpertMode */ .zv)({
            userExpertMode: expertMode
        }));
    }, [
        dispatch
    ]);
    const addPath = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((param)=>{
        let { symbol , address , chainId , name , decimals  } = param;
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_5__/* .addUserPath */ .uu)({
            symbol,
            address,
            chainId,
            name,
            decimals
        }));
    }, [
        dispatch
    ]);
    const resetPath = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((chainId)=>{
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_5__/* .resetPath */ .QY)({
            chainId
        }));
    }, [
        dispatch
    ]);
    const removePath = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((param)=>{
        let { address , chainId  } = param;
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_5__/* .removePath */ .jC)({
            address,
            chainId
        }));
    }, [
        dispatch
    ]);
    const updateUserPathType = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((userPathType)=>{
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_5__/* .updateUserPathType */ .pJ)({
            userPathType
        }));
    }, [
        dispatch
    ]);
    const addPinnedToken = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((currencyId)=>{
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_5__/* .addPinnedToken */ .P1)({
            currencyId
        }));
    }, [
        dispatch
    ]);
    const removePinnedToken = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((currencyId)=>{
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_5__/* .removePinnedToken */ .I9)({
            currencyId
        }));
    }, [
        dispatch
    ]);
    const updateSlippageTolerance = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((slippageTolerance)=>{
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_5__/* .updateUserSlippageTolerance */ .rQ)({
            userSlippageTolerance: slippageTolerance
        }));
    }, [
        dispatch
    ]);
    const updateSlippageToleranceType = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((slippageToleranceType)=>{
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_5__/* .updateUserSlippageToleranceType */ .k_)({
            slippageToleranceType
        }));
    }, [
        dispatch
    ]);
    const updateTransactionDeadlineType = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((userDeadlineType)=>{
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_5__/* .updateUserDeadlineType */ .B_)({
            userDeadlineType
        }));
    }, [
        dispatch
    ]);
    const updateTransactionDeadline = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((transactionDeadline)=>{
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_5__/* .updateUserDeadline */ .gw)({
            userDeadline: transactionDeadline
        }));
    }, [
        dispatch
    ]);
    return [
        settings,
        {
            updateExpertMode,
            updateSlippageTolerance,
            updateSlippageToleranceType,
            updateTransactionDeadline,
            updateTransactionDeadlineType,
            updateUserPathType,
            addPath,
            removePath,
            resetPath,
            addPinnedToken,
            removePinnedToken
        }
    ];
};
const useNotifications = (account)=>{
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    const notifications = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)((state)=>{
        var ref;
        return account ? (ref = state.user.notifications) === null || ref === void 0 ? void 0 : ref[account] : {};
    });
    const createNotification = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((param)=>{
        let { promise , ...rest } = param;
        const { groupTimestamp  } = rest;
        (0,_components_Toast__WEBPACK_IMPORTED_MODULE_4__/* .createToast */ .Yz)({
            ...rest,
            promise
        });
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_5__/* .createNotification */ .sc)({
            account: account ? account : "",
            notification: fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_1___default()(rest),
            timestamp: groupTimestamp
        }));
    }, [
        account,
        dispatch
    ]);
    const createSuccessNotification = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((rest)=>{
        const { groupTimestamp  } = rest;
        (0,_components_Toast__WEBPACK_IMPORTED_MODULE_4__/* .createSuccessToast */ .nj)(rest);
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_5__/* .createNotification */ .sc)({
            account: account ? account : "",
            notification: fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_1___default()(rest),
            timestamp: groupTimestamp
        }));
    }, [
        account,
        dispatch
    ]);
    const createFailedNotification = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((rest)=>{
        const { groupTimestamp  } = rest;
        (0,_components_Toast__WEBPACK_IMPORTED_MODULE_4__/* .createFailedToast */ .zb)(rest);
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_5__/* .createNotification */ .sc)({
            account: account ? account : "",
            notification: fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_1___default()(rest),
            timestamp: groupTimestamp
        }));
    }, [
        account,
        dispatch
    ]);
    const createInfoNotification = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((rest)=>{
        const { groupTimestamp  } = rest;
        (0,_components_Toast__WEBPACK_IMPORTED_MODULE_4__/* .createInfoToast */ .Bh)(rest);
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_5__/* .createNotification */ .sc)({
            account: account ? account : "",
            notification: fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_1___default()(rest),
            timestamp: groupTimestamp
        }));
    }, [
        account,
        dispatch
    ]);
    const createInlineNotification = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((param)=>{
        let { promise , ...rest } = param;
        const { groupTimestamp  } = rest;
        (0,_components_Toast__WEBPACK_IMPORTED_MODULE_4__/* .createInlineToast */ .yH)({
            ...rest,
            promise
        });
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_5__/* .createNotification */ .sc)({
            account: account ? account : "",
            notification: fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_1___default()(rest),
            timestamp: groupTimestamp
        }));
    }, [
        account,
        dispatch
    ]);
    const clearNotifications = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(()=>{
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_5__/* .clearNotifications */ .L1)({
            account: account ? account : ""
        }));
    }, [
        account,
        dispatch
    ]);
    return [
        notifications || {},
        {
            createNotification,
            clearNotifications,
            createInlineNotification,
            createSuccessNotification,
            createFailedNotification,
            createInfoNotification
        }
    ];
} /**
 *
 */  // type AddCustomTokenReturn = { addCustomToken(payload: TokenAsObject): void }
 // type AddCustomToken = () => AddCustomTokenReturn
 // export const useCustomToken: AddCustomToken = () => {
 //   const dispatch = useDispatch()
 //   const addCustomToken = useCallback(
 //     ({ symbol, address, chainId, name, decimals }: TokenAsObject) => {
 //       dispatch(addcustomtoken({ symbol, address, chainId, name, decimals }))
 //     },
 //     [dispatch]
 //   )
 //   return { addCustomToken }
 // }
 // /**
 //  *
 //   */
 //  export function useAddCustomTokens(tokens: TokenAsObject[]) {
 //    const dispatch = useAppDispatch()
 //    return useCallback(() => {
 //      dispatch(addcustomtokens(tokens))
 //    }, [tokens, dispatch])
 //  }
 // /**
 //  *
 //  */
 // export function useRemoveCustomToken({ address, chainId }: Pick<TokenAsObject, 'address' | 'chainId'>) {
 //   const dispatch = useAppDispatch()
 //   return useCallback(() => {
 //     dispatch(removecustomtoken({ address, chainId }))
 //   }, [dispatch, address, chainId])
 // }
 //
 // /**
 //  * @param param0
 //  * @returns
 //  */
 // export const useCustomTokens:UseCustomTokens = (chainId?: number)  => {
 //   const customTokens = useAppSelector((state: WithUserState) => state.user?.customTokens)
 //   const tokens = useMemo(() => {
 //     if (!chainId || !customTokens[chainId]) return {}
 //     return Object.entries(customTokens[chainId]).reduce<Record<string, Token>>(
 //       (acc, [k, { chainId, decimals, name, symbol, address }]) => {
 //         acc[k] = new Token({ chainId, decimals, name, symbol, address })
 //         return acc
 //       },
 //       {}
 //     )
 //   }, [chainId, customTokens])
 //
 //   return tokens
 // }
 /**
 *
 */  // function serializeToken(token: Token): SerializedToken {
 //   return {
 //     chainId: token.chainId,
 //     address: token.address,
 //     decimals: token.decimals,
 //     symbol: token.symbol,
 //     name: token.name,
 //   }
 // }
 /**
 *
 */  // function deserializeToken(serializedToken: SerializedToken): Token {
 //   return new Token({
 //     chainId: serializedToken.chainId,
 //     address: serializedToken.address,
 //     decimals: serializedToken.decimals,
 //     symbol: serializedToken.symbol,
 //     name: serializedToken.name
 //   })
 // }
 // export function getFarmFilter(): string {
 //   return useAppSelector((state) => state.user.userFarmFilter)
 // }
 //
 // export function getVaultFilter(): string {
 //   return useAppSelector((state) => state.user.userVaultFilter)
 // }
 // export function useUpdateFarmFilter(): (filter: string) => void {
 //   // const dispatch = useAppDispatch()
 //   // dispatch(updateUserFarmFilter({ userFarmFilter: filter }))
 //   const dispatch = useDispatch<AppDispatch>()
 //   return useCallback(
 //     (filter: string) => {
 //       dispatch(updateUserFarmFilter({ userFarmFilter: filter }))
 //     },
 //     [dispatch]
 //   )
 // }
 // export function useUpdateVaultFilter(): (filter: string) => void {
 //   // const dispatch = useAppDispatch()
 //   // dispatch(updateUserVaultFilter({ userVaultFilter: filter }))
 //   const dispatch = useDispatch<AppDispatch>()
 //   return useCallback(
 //     (filter: string) => {
 //       dispatch(updateUserVaultFilter({ userVaultFilter: filter }))
 //     },
 //     [dispatch]
 //   )
 // }
 //
 // export function useIsExpertMode(): boolean {
 //   return useAppSelector((state) => state.user.userExpertMode)
 // }
 //
 // export function useExpertModeManager(): [boolean, () => void] {
 //   const dispatch = useAppDispatch()
 //   const expertMode = useIsExpertMode()
 //
 //   const toggleSetExpertMode = useCallback(() => {
 //     dispatch(updateUserExpertMode({ userExpertMode: !expertMode }))
 //   }, [expertMode, dispatch])
 //
 //   return [expertMode == true ? true : false, toggleSetExpertMode]
 // }
 //
 // export function useUserSingleHopOnly(): [boolean, (newSingleHopOnly: boolean) => void] {
 //   const dispatch = useAppDispatch()
 //
 //   const singleHopOnly = useAppSelector((state) => state.user.userSingleHopOnly)
 //
 //   const setSingleHopOnly = useCallback(
 //     (newSingleHopOnly: boolean) => {
 //       ReactGA.event({
 //         category: 'Routing',
 //         action: newSingleHopOnly ? 'enable single hop' : 'disable single hop',
 //       })
 //       dispatch(updateUserSingleHopOnly({ userSingleHopOnly: newSingleHopOnly }))
 //     },
 //     [dispatch]
 //   )
 //
 //   return [singleHopOnly, setSingleHopOnly]
 // }
 //
 // export function useSetUserSlippageTolerance(): (slippageTolerance: Percent | 'auto') => void {
 //   const dispatch = useAppDispatch()
 //
 //   return useCallback(
 //     (userSlippageTolerance: Percent | 'auto') => {
 //       let value: 'auto' | number
 //       try {
 //         value =
 //           userSlippageTolerance === 'auto' ? 'auto' : JSBI.toNumber(userSlippageTolerance.multiply(10_000).quotient)
 //       } catch (error) {
 //         value = 'auto'
 //       }
 //       dispatch(
 //         updateUserSlippageTolerance({
 //           userSlippageTolerance: value,
 //         })
 //       )
 //     },
 //     [dispatch]
 //   )
 // }
 //
 // /**
 //  * Return the user's slippage tolerance, from the redux store, and a function to update the slippage tolerance
 //  */
 // export function useUserSlippageTolerance(): Percent | 'auto' {
 //   const userSlippageTolerance = useAppSelector((state) => {
 //     return state.user.userSlippageTolerance
 //   })
 //
 //   return useMemo(
 //     () => (userSlippageTolerance === 'auto' ? 'auto' : new Percent(userSlippageTolerance, 10_000)),
 //     [userSlippageTolerance]
 //   )
 // }
 //
 // export function useUserTransactionTTL(): [number, (slippage: number) => void] {
 //   const dispatch = useDispatch<AppDispatch>()
 //   const userDeadline = useSelector<AppState, AppState['user']['userDeadline']>((state) => {
 //     return state.user.userDeadline
 //   })
 //
 //   const setUserDeadline = useCallback(
 //     (userDeadline: number) => {
 //       dispatch(updateUserDeadline({ userDeadline }))
 //     },
 //     [dispatch]
 //   )
 //
 //   return [userDeadline, setUserDeadline]
 // }
 /**
 *
 */  // export function useAddUserToken(): (token: Token) => void {
 //   const dispatch = useDispatch<AppDispatch>()
 //   return useCallback(
 //     (token: Token) => {
 //       dispatch(addSerializedToken({ serializedToken: serializeToken(token) }))
 //     },
 //     [dispatch]
 //   )
 // }
 //
 // /**
 //  * @returns
 //  */
 // export function useRemoveUserAddedToken(): (chainId: number, address: string) => void {
 //   const dispatch = useAppDispatch()
 //   return useCallback(
 //     (chainId: number, address: string) => {
 //       dispatch(removeSerializedToken({ chainId, address }))
 //     },
 //     [dispatch]
 //   )
 // }
 //
 // /**
 //  *
 //  * @returns
 //  */
 // export function useUserAddedTokens(): Token[] {
 //   const { chainId } = useActiveWeb3React()
 //   const serializedTokensMap = useAppSelector(({ user: { tokens } }) => tokens as Token[])
 //
 //   return useMemo(() => {
 //     if (!chainId) return []
 //     return Object.values(serializedTokensMap?.[chainId] ?? {}).map(deserializeToken)
 //   }, [serializedTokensMap, chainId])
 // }
 /**
 *
 * @param pair
 * @returns
 */  // function serializePair(pair: Pair): SerializedPair {
 //   return {
 //     token0: serializeToken(pair.token0),
 //     token1: serializeToken(pair.token1),
 //   }
 // }
 /**
 *
 */  // export function usePairAdder(): (pair: Pair) => void {
 //   const dispatch = useAppDispatch()
 //
 //   return useCallback(
 //     (pair: Pair) => {
 //       dispatch(addSerializedPair({ serializedPair: serializePair(pair) }))
 //     },
 //     [dispatch]
 //   )
 // }
 // /**
 //  *
 //  * @returns
 //  */
 // export function useURLWarningVisible(): boolean {
 //   return useAppSelector((state: AppState) => state.user.URLWarningVisible)
 // }
 //
 // export function useURLWarningToggle(): () => void {
 //   const dispatch = useAppDispatch()
 //   return useCallback(() => dispatch(toggleURLWarning()), [dispatch])
 // }
 /**
 * Given two tokens return the liquidity token that represents its liquidity shares
 * @param tokenA one of the two tokens
 * @param tokenB the other token
 */  // export function toV2LiquidityToken([tokenA, tokenB]: [Token, Token]): Token {
 //   return tokenA && tokenB && tokenA.chainId === tokenB.chainId && FACTORY_ADDRESS[tokenA.chainId]
 //     ? new Token(
 //         tokenA.chainId,
 //         computePairAddress({ factoryAddress: FACTORY_ADDRESS[tokenA.chainId], tokenA, tokenB }),
 //         18,
 //         'UNI-V2',
 //         'Uniswap V2'
 //       )
 //     : undefined
 // }
 /**
 * Returns all the pairs of tokens that are tracked by the user for the current chain ID.
 */  // export function useTrackedTokenPairs(): [Token, Token][] {
 //   const { chainId } = useActiveWeb3React()
 //   const tokens = useAllTokens()
 //
 //   // pairs for every token against every base
 //   const generatedPairs: [Token, Token][] = useMemo(
 //     () =>
 //       chainId
 //         ? flatMap(Object.keys(tokens), (tokenAddress) => {
 //             const token = tokens[tokenAddress]
 //             // for each token on the current chain,
 //             return (
 //               // loop though all bases on the current chain
 //               (BASES_TO_TRACK_LIQUIDITY_FOR[chainId] ?? [])
 //                 // to construct pairs of the given token with each base
 //                 .map((base) => {
 //                   if (base.address === token.address) {
 //                     return null
 //                   } else {
 //                     return [base, token]
 //                   }
 //                 })
 //                 .filter((p): p is [Token, Token] => p !== null)
 //             )
 //           })
 //         : [],
 //     [tokens, chainId]
 //   )
 //
 //   // pairs saved by users
 //   const savedSerializedPairs = useAppSelector(({ user: { pairs } }) => pairs)
 //
 //   const userPairs: [Token, Token][] = useMemo(() => {
 //     if (!chainId || !savedSerializedPairs) return []
 //     const forChain = savedSerializedPairs[chainId]
 //     if (!forChain) return []
 //
 //     return Object.keys(forChain).map((pairId) => {
 //       return [deserializeToken(forChain[pairId].token0), deserializeToken(forChain[pairId].token1)]
 //     })
 //   }, [savedSerializedPairs, chainId])
 //
 //   const combinedList = useMemo(() => userPairs.concat(generatedPairs), [generatedPairs, userPairs])
 //
 //   return useMemo(() => {
 //     // dedupes pairs of tokens in the combined list
 //     const keyed = combinedList.reduce<{ [key: string]: [Token, Token] }>((memo, [tokenA, tokenB]) => {
 //       const sorted = tokenA.sortsBefore(tokenB)
 //       const key = sorted ? `${tokenA.address}:${tokenB.address}` : `${tokenB.address}:${tokenA.address}`
 //       if (memo[key]) return memo
 //       memo[key] = sorted ? [tokenA, tokenB] : [tokenB, tokenA]
 //       return memo
 //     }, {})
 //
 //     return Object.keys(keyed).map((key) => keyed[key])
 //   }, [combinedList])
 // }
 //
 // export function useUserArcherUseRelay(): [boolean, (newUseRelay: boolean) => void] {
 //   const dispatch = useAppDispatch()
 //
 //   const useRelay = useSelector<AppState, AppState['user']['userArcherUseRelay']>(
 //     (state) => state.user.userArcherUseRelay
 //   )
 //
 //   const setUseRelay = useCallback(
 //     (newUseRelay: boolean) => {
 //       dispatch(updateUserArcherUseRelay({ userArcherUseRelay: newUseRelay }))
 //     },
 //     [dispatch]
 //   )
 //
 //   return [useRelay, setUseRelay]
 // }
 //
 // export function useUserArcherGasPrice(): [string, (newGasPrice: string) => void] {
 //   const dispatch = useAppDispatch()
 //   const userGasPrice = useSelector<AppState, AppState['user']['userArcherGasPrice']>((state) => {
 //     return state.user.userArcherGasPrice
 //   })
 //
 //   const setUserGasPrice = useCallback(
 //     (newGasPrice: string) => {
 //       dispatch(updateUserArcherGasPrice({ userArcherGasPrice: newGasPrice }))
 //     },
 //     [dispatch]
 //   )
 //
 //   return [userGasPrice, setUserGasPrice]
 // }
 //
 // export function useUserArcherETHTip(): [string, (newETHTip: string) => void] {
 //   const dispatch = useAppDispatch()
 //   const userETHTip = useSelector<AppState, AppState['user']['userArcherETHTip']>((state) => {
 //     return state.user.userArcherETHTip
 //   })
 //
 //   const setUserETHTip = useCallback(
 //     (newETHTip: string) => {
 //       dispatch(updateUserArcherETHTip({ userArcherETHTip: newETHTip }))
 //     },
 //     [dispatch]
 //   )
 //
 //   return [userETHTip, setUserETHTip]
 // }
 //
 // export function useUserArcherGasEstimate(): [string, (newGasEstimate: string) => void] {
 //   const dispatch = useAppDispatch()
 //   const userGasEstimate = useSelector<AppState, AppState['user']['userArcherGasEstimate']>((state) => {
 //     return state.user.userArcherGasEstimate
 //   })
 //
 //   const setUserGasEstimate = useCallback(
 //     (newGasEstimate: string) => {
 //       dispatch(
 //         updateUserArcherGasEstimate({
 //           userArcherGasEstimate: newGasEstimate,
 //         })
 //       )
 //     },
 //     [dispatch]
 //   )
 //
 //   return [userGasEstimate, setUserGasEstimate]
 // }
 //
 // export function useUserArcherTipManualOverride(): [boolean, (newManualOverride: boolean) => void] {
 //   const dispatch = useAppDispatch()
 //   const userTipManualOverride = useSelector<AppState, AppState['user']['userArcherTipManualOverride']>((state) => {
 //     return state.user.userArcherTipManualOverride
 //   })
 //
 //   const setUserTipManualOverride = useCallback(
 //     (newManualOverride: boolean) => {
 //       dispatch(
 //         updateUserArcherTipManualOverride({
 //           userArcherTipManualOverride: newManualOverride,
 //         })
 //       )
 //     },
 //     [dispatch]
 //   )
 //
 //   return [userTipManualOverride, setUserTipManualOverride]
 // }
 //
 // /**
 //  * Same as above but replaces the auto with a default value
 //  * @param defaultSlippageTolerance the default value to replace auto with
 //  */
 // export function useUserSlippageToleranceWithDefault(defaultSlippageTolerance: Percent): Percent {
 //   const allowedSlippage = useUserSlippageTolerance()
 //   return useMemo(
 //     () => (allowedSlippage === 'auto' ? defaultSlippageTolerance : allowedSlippage),
 //     [allowedSlippage, defaultSlippageTolerance]
 //   )
 // }
 //
;


/***/ })

}]);